if (!customElements.get('akuma-product-card')) {
  customElements.define('akuma-product-card', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.image = this.querySelector('[data-card-image]');
      this.images = [...(this.querySelector('[data-card-images]')?.content.children || [])].map(item => ({ ...item.dataset }));
      this.index = Math.max(0, this.images.findIndex(item => item.imageId === this.image?.dataset.imageId));
      this.swatches = [...this.querySelectorAll('[data-card-color]')];
      this.swatches.forEach(swatch => {
        swatch.setAttribute('role', 'button');
        swatch.setAttribute('aria-pressed', 'false');
      });
      this.addEventListener('click', event => {
        const swatch = event.target.closest('[data-card-color]');
        if (!swatch) return;
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        let index = this.images.findIndex(item => item.imageId && item.imageId === swatch.dataset.imageId);
        if (index < 0 && swatch.dataset.imageSrc) {
          index = this.images.findIndex(item => item.src === swatch.dataset.imageSrc);
          if (index < 0) {
            this.images.push({ imageId: swatch.dataset.imageId, src: swatch.dataset.imageSrc,
              srcset: swatch.dataset.imageSrcset || '', alt: swatch.dataset.imageAlt || swatch.dataset.cardColor });
            index = this.images.length - 1;
          }
        }
        if (index >= 0) {
          this.showImage(index);
          if (this.hasAttribute('data-native-card-hover')) this.setAttribute('data-color-preview', '');
        }
        this.swatches.forEach(item => item.setAttribute('aria-pressed', String(item === swatch)));
        this.querySelectorAll('.card__heading a').forEach(link => { link.href = swatch.href; });
        this.querySelector('[data-card-status]').textContent = swatch.getAttribute('aria-label');
      }, { signal: this.controller.signal });
      this.addEventListener('pointerleave', () => this.removeAttribute('data-color-preview'), { signal: this.controller.signal });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.removeAttribute('data-color-preview');
      }, { signal: this.controller.signal });
      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('[data-card-color]')) {
          event.preventDefault();
          event.target.click();
        }
      }, { signal: this.controller.signal });
    }
    showImage(index) {
      if (!this.image || !this.images.length) return;
      this.index = (index + this.images.length) % this.images.length;
      const next = this.images[this.index];
      this.image.srcset = next.srcset;
      this.image.src = next.src;
      this.image.alt = next.alt;
      this.querySelector('[data-card-status]').textContent = `${this.index + 1} / ${this.images.length}`;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
